module.exports = __webpack_public_path__ + "teqbahn-assets/media/5.7b3447d7.png";